// Gerenciamento de favoritos (localStorage)

const FAVORITES_KEY = 'econodata_favorites';

export interface FavoriteCompany {
  cnpj_completo: string;
  cnpj_basico?: string;
  razao_social: string;
  uf?: string;
  situacao_descricao?: string;
  addedAt: string;
}

function normalizeCNPJ(value: string): string {
  return (value || '').replace(/\D/g, '');
}

export function getFavorites(): FavoriteCompany[] {
  try {
    const data = localStorage.getItem(FAVORITES_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export function addFavorite(company: any): boolean {
  try {
    const favorites = getFavorites();

    const cnpjCompleto = normalizeCNPJ(company.cnpj_completo || company.id || '');
    const cnpjBasico = normalizeCNPJ(company.cnpj_basico || cnpjCompleto.substring(0, 8));
    if (!cnpjCompleto) {
      return false;
    }
    
    // Verificar se já existe
    if (
      favorites.some((f: any) => {
        const favCompleto = normalizeCNPJ(f.cnpj_completo || '');
        const favBasico = normalizeCNPJ(f.cnpj_basico || '');
        if (favCompleto) return favCompleto === cnpjCompleto;
        if (favBasico) return favBasico === cnpjBasico;
        return false;
      })
    ) {
      return false;
    }
    
    favorites.push({
      cnpj_completo: cnpjCompleto,
      cnpj_basico: cnpjBasico,
      razao_social: company.razao_social,
      uf: company.uf,
      situacao_descricao: company.situacao_descricao || company.situacao,
      addedAt: new Date().toISOString(),
    });
    
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
    return true;
  } catch {
    return false;
  }
}

export function removeFavorite(cnpj_completo: string): boolean {
  try {
    const favorites = getFavorites();
    const cnpjCompleto = normalizeCNPJ(cnpj_completo);
    const cnpjBasico = cnpjCompleto.substring(0, 8);
    const filtered = favorites.filter((f: any) => {
      const favCompleto = normalizeCNPJ(f.cnpj_completo || '');
      const favBasico = normalizeCNPJ(f.cnpj_basico || '');
      if (favCompleto) return favCompleto !== cnpjCompleto;
      if (favBasico) return favBasico !== cnpjBasico;
      return true;
    });
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(filtered));
    return true;
  } catch {
    return false;
  }
}

export function isFavorite(cnpj_completo: string): boolean {
  const favorites = getFavorites();
  const cnpjCompleto = normalizeCNPJ(cnpj_completo);
  const cnpjBasico = cnpjCompleto.substring(0, 8);
  return favorites.some((f: any) => {
    const favCompleto = normalizeCNPJ(f.cnpj_completo || '');
    const favBasico = normalizeCNPJ(f.cnpj_basico || '');
    if (favCompleto) return favCompleto === cnpjCompleto;
    if (favBasico) return favBasico === cnpjBasico;
    return false;
  });
}

export function clearFavorites(): void {
  localStorage.removeItem(FAVORITES_KEY);
}
